// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-dynamic-dropdown>button:focus, .softlite-dynamic-dropdown__item:focus{
    outline: none !important;
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/dynamic/dropdown/dropdown.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B","sourcesContent":[".softlite-dynamic-dropdown>button:focus, .softlite-dynamic-dropdown__item:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
